import { CronObject } from 'src/components/most/list/scheduled-jobs/form/types';
import dayjs from 'dayjs';
import { CronTypes } from 'src/components/most/list/scheduled-jobs/fields/cron';

export const getCron = (cronObject: CronObject) => {
  let cron: string;
  const time = dayjs(cronObject.time);
  const date = dayjs(cronObject.date);

  switch (cronObject.recurringType) {
    case CronTypes.Day:
      cron = `${time.minute()} ${time.hour()} */${
        cronObject.recurringValue
      } * *`;
      break;
    case CronTypes.Week:
      cron = `${time.minute()} ${time.hour()} */${
        (cronObject.recurringValue || 1) * 7
      } * ${date.day()}`;
      break;
    case CronTypes.Month:
      cron = `${time.minute()} ${time.hour()} ${date.day()} */${
        cronObject.recurringValue
      } *`;
      break;
    default:
      cron = '';
  }
  return cron;
};

export const parseCron = (cron: string) => {
  if (!cron) {
    return undefined;
  }

  const [minute, hour, day, month, week] = cron.split(' ');

  if (week !== '*') {
    const value = (+day.split('/')[1] || 1) / 7;
    return { type: CronTypes.Week, value };
  }

  if (month !== '*') {
    const value = +month.split('/')[1] || 1;
    return { type: CronTypes.Month, value };
  }

  const value = +day.split('/')[1] || 1;
  return { type: CronTypes.Day, value };
};
